module.exports = __webpack_public_path__ + "img/ho-andano.78997532.jpg";